import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import { Layout } from 'Components/Base';
import { withOffset } from 'Context/LayoutContext';

const FixedLayout = withTheme(
  ({
    theme,
    renderHeader,
    renderSidebar,
    renderChildren,
    renderFooter,
    childrenProps,
    footerProps,
    contentProps,
  }) => {
    return (
      <Layout
        top={renderHeader()}
        // FIXME: SKOOLDIO-5053 Remove APP_TOP_OFFSET param and use `safe area insets` instead
        topProps={{
          pb: [
            `${theme.space.CLASSROOM_NAVBAR_HEIGHT + theme.space.APP_TOP_OFFSET}px`,
            `${theme.space.CLASSROOM_NAVBAR_HEIGHT}px`,
          ],
          height: [
            `${theme.space.CLASSROOM_NAVBAR_HEIGHT + theme.space.APP_TOP_OFFSET}px`,
            `${theme.space.CLASSROOM_NAVBAR_HEIGHT}px`,
          ],
          width: 1,
        }}
        left={renderSidebar()}
        leftProps={{
          // width: '100%',
          flex: '0 0',
        }}
        main={renderChildren()}
        mainProps={{
          style: {
            // height: '100%',
            overflowY: 'auto',
            // minHeight: `calc(100vh - ${theme.space.CLASSROOM_NAVBAR_HEIGHT}px)`,
            '-webkit-overflow-scrolling': 'auto', // Workaround YouTube fullscreen video js on Safari
          },
          ...childrenProps,
        }}
        bottom={renderFooter()}
        bottomProps={footerProps}
        // to expand full height for main
        outerContainerProps={{
          style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
        // FIXME: SKOOLDIO-4804
        innerContainerProps={{
          style: {
            height: `calc(100% - ${theme.space.CLASSROOM_NAVBAR_HEIGHT}px)`,
            // flex: '1 0'
          },
          ...contentProps,
        }}
      />
    );
  }
);

FixedLayout.propTypes = {
  renderHeader: PropTypes.func,
  renderFooter: PropTypes.func,
  renderSidebar: PropTypes.func,
  renderChildren: PropTypes.func,
};
FixedLayout.defaultProps = {
  renderHeader: () => {},
  renderFooter: () => {},
  renderChildren: () => {},
  renderSidebar: () => {},
};

export default withOffset(FixedLayout);
